// API Types for BirdDog Backend Integration

export interface ApiTimberProduct {
  name: string
  unit: string
  estimated_volume: number
}

export interface ApiSaleRequest {
  name: string
  location_text: string
  description?: string
  boundary_geom?: GeoJSON.MultiPolygon
  sale_type: "pay as cut" | "lump sum"
  status?: "draft" | "active" | "closed"
  bid_start_datetime: string // ISO datetime string
  bid_stop_datetime: string // ISO datetime string
  bid_select_datetime: string // ISO datetime string
  bidding_tc?: string
  contract_tc?: string
  inventory_description?: string
  timber_products: ApiTimberProduct[]
}

export interface ApiSaleResponse {
  id: number
  name: string
  location_text: string
  description?: string
  boundary_geom?: GeoJSON.MultiPolygon
  sale_type: "pay as cut" | "lump sum"
  status: "draft" | "active" | "closed"
  created_at: string // ISO datetime string
  updated_at: string // ISO datetime string
  published_at?: string // ISO datetime string
  bid_start_datetime: string // ISO datetime string
  bid_stop_datetime: string // ISO datetime string
  bid_select_datetime: string // ISO datetime string
  bidding_tc?: string
  contract_tc?: string
  inventory_description?: string
  timber_products: ApiTimberProduct[]
  bid_count: number
}

// Error response types based on API documentation
export interface ApiFieldError {
  [fieldName: string]: string[]
}

export interface ApiValidationError {
  error: string
  details: string
}

export interface ApiServerError {
  error: string
}

export type ApiError = ApiFieldError | ApiValidationError | ApiServerError

// Helper type guards
export const isFieldError = (error: any): error is ApiFieldError => {
  return typeof error === "object" && error !== null && !error.error
}

export const isValidationError = (error: any): error is ApiValidationError => {
  return (
    typeof error === "object" && error !== null && error.error && error.details
  )
}

export const isServerError = (error: any): error is ApiServerError => {
  return (
    typeof error === "object" && error !== null && error.error && !error.details
  )
}

// Bid API Types
export interface ApiProductPrice {
  product_name: string
  price_per_unit: number
}

export interface ApiBidRequest {
  bid_type: "lump sum" | "pay as cut"
  total_amount?: string // For lump sum bids (as decimal string)
  product_prices?: ApiProductPrice[] // For pay as cut bids
}

export interface ApiBidResponse {
  id: number
  sale: number
  bidder_name: string
  bid_type: "lump sum" | "pay as cut"
  total_amount?: string
  product_prices?: ApiProductPrice[]
  submitted_at: string | null // ISO datetime string or null for drafts
  created_at: string // ISO datetime string
  updated_at: string // ISO datetime string
}
